import { Orders } from 'model/Orders'
import {
  bloodChemistry,
  bloodHematology,
  dermatoscope,
  deviceOrder,
  Devices,
  DevicesMap,
  edanEcg,
  edanVitals,
  eko,
  generalLab,
  glucometer,
  orthostaticBp,
  otoscope,
  rapidCovidFlu,
  rapidStrepA,
  rapidTestNames,
  scale,
  ultrasound,
  urine,
} from 'model/Devices'
import { colorDef } from 'vdg-patients/common/test-examination/VdgTestButton'
import { ExaminationStatus, patientFileReason } from './PatientFile'
import InternalExaminationPlan from './InternalExaminationPlan'
import { scheduleTypeDef } from 'vdg-patients/appointment/diagnosis/test-examination/VdgTestModal'
import moment from 'moment'

const createExList = () => {
  let tmpTest: any[] = [...Devices, ...Orders]
  let newTests: any[] = []
  tmpTest.map((test: any) => {
    if (test.kind === 'device') {
      if (test.types.length > 1) {
        test.types.map((type: any) => {
          newTests.push({ ...test, ...{ types: [type] } })
        })
      } else {
        newTests.push(test)
      }
    } else {
      //order
      newTests.push(test)
    }
  })
  return newTests
}

const createExNameList = () => {
  let devicesName = [...Devices].map(dev => dev.name)
  let ordersName = [...Orders].map(dev => dev.label)
  let NameTests: any[] = [...devicesName, ...ordersName].filter((name: String) => name !== 'Order')

  return NameTests
}
const getUiExList = (exList: any) => {
  return exList
    .filter((test: any) => test.value !== deviceOrder.value && test.value != 'custom')
    .map((test: any) => {
      if (test.kind === 'device') {
        return {
          label: test.name + '-' + test.types[0],
          value: JSON.stringify(test),
        }
      } else
        return {
          label: test.label,
          value: JSON.stringify(test),
        }
    })
}

const temp = createExList()

const onlyNames = createExNameList()

export const ExaminationList = temp
export const ExaminationNameList = onlyNames
export const ExaminationForUiList = getUiExList(temp)
export const setExaminationDocument = (examination: any) => {
  examination.isDone = getDoneStatus(examination)
  examination.isExternalExamination = getInternalExternalStatus(examination)
  examination.titleToDisplay = getExaminationTitle(examination)
  examination.isExaminationOrReferral = isExaminationOrReferral(examination)
  examination.needsToBeWatched = doesNeedToBeWatched(examination)
  examination.testDate = getTestDate(examination)
  examination.isInterpretedType = getInterpertedType(examination)
  return examination
}

const getDoneStatus = (examination: any): boolean => {
  return examination?.category === 'examination' && examination?.details?.done
}

const getInternalExternalStatus = (examination: any): boolean => {
  return examination?.category !== 'result' && examination?.category !== 'examination'
}

export const getExaminationTitle = (examination: any): string => {
  return (
    (examination?.category === 'examination' &&
      ((examination?.details?.name === deviceOrder?.name && examination?.details?.orderselected) ||
        returnExamName(examination?.details?.name, examination?.details?.type))) ||
    (examination?.category === 'referral' && examination?.referralDetails?.title) ||
    examination?.category
  )
}

export function returnExamName(examName: string, examType = '') {
  const examNameLower = examName?.toLowerCase()
  const deviceObj = DevicesMap.get(examNameLower)

  let examNameFinal = deviceObj ? deviceObj.name : examName

  switch (deviceObj?.name) {
    case glucometer.name:
      examNameFinal = 'Glucometer - Blood glucose'
      break
    case edanEcg.name:
      examNameFinal = 'ECG'
      break
    case edanVitals.name:
      examNameFinal = 'Vital signs'
      break
    case scale.name:
      examNameFinal = 'Weight'
      break
    case eko.name:
      switch (examType) {
        case eko.types[0]:
          examNameFinal = 'Lung auscultation'
          break
        case eko.types[1]:
          examNameFinal = 'Heart auscultation'
          break

        default:
          break
      }
      break
    case deviceOrder.name:
      examNameFinal = `${deviceOrder.name}${examType ? ` - ${examType}` : ''}`
      break
    case dermatoscope.name:
      switch (examType) {
        case dermatoscope.types[0]:
        case dermatoscope.types[1]:
          examNameFinal = `Autoscope - ${examType}`
          break
        case dermatoscope.types[2]:
          examNameFinal = `Dermatoscope - ${examType}`
          break
        default:
          break
      }
      break
    case otoscope.name:
      switch (examType) {
        case otoscope.types[0]:
        case otoscope.types[1]:
        case otoscope.types[2]:
          examNameFinal = `Autoscope - ${examType}`
          break
        case otoscope.types[3]:
          examNameFinal = `Dermatoscope - ${examType}`
          break
        default:
          break
      }
      break
    case ultrasound.name:
      examNameFinal = `${ultrasound.name}${examType ? ` - ${examType}` : ''}`
      break
    case bloodChemistry.name:
      examNameFinal = bloodChemistry.name
      break
    case bloodHematology.name:
      examNameFinal = 'CBC'
      break
    case urine.name:
      examNameFinal = 'Urine Dipstick Test'
      break
    case rapidStrepA.name:
      examNameFinal = 'Strep A rapid test'
      break
    case rapidCovidFlu.name:
      examNameFinal = 'COVID-19 + Influenza A/B rapid test'
      break
    case orthostaticBp.name:
      examNameFinal = 'Orthostatic Blood Pressure Test'
      break
    default:
      examNameFinal = examName
      break
  }
  return examNameFinal
}

export const getSchedulePlanTitle = (schedulePlan: InternalExaminationPlan): string => {
  return (
    (schedulePlan.test.kind === deviceOrder?.kind && schedulePlan.test.value) ||
    `${schedulePlan.test.name} - ${schedulePlan.test.types[0]}`
  )
}

export const getSchedulePlanDetails = (schedulePlan: InternalExaminationPlan): string => {
  let schedulePlanDetails = ''
  if (schedulePlan.scheduleType === scheduleTypeDef.every) {
    schedulePlanDetails += `${schedulePlan.scheduleType} ${schedulePlan.everyXHours} hours`
  } else if (schedulePlan.scheduleType === scheduleTypeDef.multi) {
    schedulePlanDetails += `${schedulePlan.timesADay} time${
      (schedulePlan.timesADay && schedulePlan.timesADay > 1 && 's') || ''
    } a day`
  } else if (schedulePlan.scheduleType === scheduleTypeDef.continuous) {
    schedulePlanDetails += `${schedulePlan.severity}`
  }
  return schedulePlanDetails
}

export const getTestDate = (examination: any): string => {
  const testDate = examination.testDate
  return testDate
}

export const getInterpertedType = (examination: any): boolean => {
  const isInterpertedExamType = examination?.details?.name === ultrasound?.name
  return isInterpertedExamType
}

const isExaminationOrReferral = (examination: any): boolean => {
  return examination?.category === 'examination' || examination?.category === 'referral'
}

export const getExamIconColor = (exam: any): colorDef => {
  let examIconColor
  if (exam?.needsToBeWatched) {
    examIconColor = colorDef.red
  } else if (moment(exam.minTime) < moment()) {
    examIconColor = colorDef.orange
  } else {
    examIconColor = colorDef.grey
  }
  return examIconColor
}

export const getScheduleIconColor = (schedulePlan: InternalExaminationPlan): colorDef => {
  let examIconColor
  if (moment(schedulePlan.endPlanDate).endOf('day') > moment()) examIconColor = colorDef.grey
  else {
    examIconColor = colorDef.red
  }
  return examIconColor
}

const doesNeedToBeWatched = (examination: any): boolean => {
  return examination.isDone && examination?.examinationStatus !== ExaminationStatus.viewdTestResult
}

/**
 * A completed examination is "unread" until a provider opens it and it is
 * marked `viewdTestResult`.
 *
 * For a referral-backed examination the read status lives on the linked *result*
 * document (see ExaminationsModal, which writes `examinationStatus` onto the
 * patientMedicalResult), so the matching result is consulted first and the
 * examination's own status is only used as a fallback. Reading the live status
 * rather than the `needsToBeWatched` snapshot means the UI updates as soon as
 * the store refreshes after a result is opened.
 */
export const isExaminationUnread = (
  examination: any,
  medicalReferralResults: any[] = [],
): boolean => {
  const linkedResult = medicalReferralResults.find((res: any) => res?.referral === examination?._id)
  const statusSource = linkedResult ?? examination

  return statusSource?.examinationStatus !== ExaminationStatus.viewdTestResult
}

/**
 * Sorts completed examinations newest-first without mutating the source array.
 * Entries with a missing or unparseable date sort last while keeping their
 * relative order, so an unreadable date never hides a row at the top.
 */
export const sortExaminationsByDateDesc = <T extends { testDate?: any }>(
  examinations: T[],
): T[] => {
  const toTimestamp = (examination: T): number => {
    const parsed = moment(examination?.testDate)
    return parsed.isValid() ? parsed.valueOf() : Number.NEGATIVE_INFINITY
  }

  return [...examinations].sort((a, b) => toTimestamp(b) - toTimestamp(a))
}

/**
 * Order priority, in the same three bands the top navbar sorts patients into.
 *
 * Banded off `reason`, because that is what the server bands off too: each entry in the navbar's
 * own data pairs a reason with its verdict — `testASAP` and `outOfRangeSignificant` → emergency,
 * `nurseDiscussionUrgent` → urgent — and an item with no reason is not raised at all.
 *
 * Note `outOfRangeSignificant` lands in two places on purpose: it makes the order STAT here and
 * marks the result critical in `getReasonSeverity`. Those are different statements — how fast the
 * test is treated, and what the result says — and a row shows both.
 *
 * Deliberately not time-based. `changeToUrgentTime` looks like an escalation deadline but is
 * stamped equal to `createdAt` on these orders, so treating "deadline passed" as urgent promoted
 * every non-ASAP order a second after it was placed — an ultrasound ordered within the hour came
 * out Urgent when the navbar counts it Standard.
 *
 * Priority is about how fast the test was wanted, not about the result — an abnormal finding is
 * `getReasonSeverity`, and whether anyone has looked at it is `isExaminationUnread`.
 */
export enum ExamPriority {
  stat = 'stat',
  urgent = 'urgent',
  standard = 'standard',
}

// Matched per '#'-separated part, since a reason can combine a nurse assessment with a finding
// (e.g. 'nurseAssesmentUrgent#outOfRangeSignificant', which is STAT on the strength of its
// out-of-range part alone).
const STAT_REASON_PARTS = [patientFileReason.testASAP, patientFileReason.outOfRangeSignificant]

const URGENT_REASON_PARTS = [
  'urgent',
  'aiUrgent',
  'ASAP',
  'nurseAssesmentUrgent',
  'nurseDiscussionUrgent',
]

/** i18n keys, reused from the navbar so the two can never word the same band differently. */
export const EXAM_PRIORITY_LABEL_KEY: Record<ExamPriority, string> = {
  [ExamPriority.stat]: 'dashboard.emergency',
  [ExamPriority.urgent]: 'dashboard.urgent',
  [ExamPriority.standard]: 'dashboard.generalCases',
}

export const getExamPriority = (exam: any): ExamPriority => {
  const reasonParts = String(exam?.reason ?? '').split('#')

  // withIn is checked alongside the reason because it is set at ordering time, whereas a
  // not-yet-performed order may still be waiting for its reason.
  if (
    exam?.withIn === 'ASAP' ||
    reasonParts.some(part => STAT_REASON_PARTS.includes(part as patientFileReason))
  ) {
    return ExamPriority.stat
  }

  if (reasonParts.some(part => URGENT_REASON_PARTS.includes(part))) {
    return ExamPriority.urgent
  }

  return ExamPriority.standard
}

export const isMonitoringOrLabs = (record: any) => {
  const isMonitoring = [edanVitals.name, scale.name, glucometer.name].includes(
    record?.details?.name,
  )
  const isLabs = [
    generalLab.name,
    bloodChemistry.name,
    bloodHematology.name,
    urine.name,
    ...rapidTestNames,
  ].includes(record?.details?.name)
  return { isMonitoring, isLabs }
}
